import Handedness from "./Handedness.js";
import PitchType from "./PitchType.js";
import RankingScopeContext from "./RankingScopeContext.js";

const RankingScope = {
    context: { key: 'context', name: 'context', type: 'STRING', enum: RankingScopeContext },
    sessionId: { key: 'sessionId', name: 'sessionId', type: 'NUMBER' },
    teamId: { key: 'teamId', name: 'teamId', type: 'NUMBER' },
    opponentTeamId: { key: 'opponentTeamId', name: 'opponentTeamId', type: 'NUMBER' },
    tagId: { key: 'tagId', name: 'tagId', type: 'NUMBER' },
    handedness: { key: 'handedness', name: 'handedness', type: 'STRING', enum: Handedness, enumDefault: Handedness.Unidentified.key },
    opponentId: { key: 'opponentId', name: 'opponentId', type: 'NUMBER' },
    opponentHandedness: { key: 'opponentHandedness', name: 'opponentHandedness', type: 'STRING', enum: Handedness, enumDefault: Handedness.Unidentified.key },
    pitchType: { key: 'pitchType', name: 'pitchType', type: 'STRING', enum: PitchType, enumDefault: PitchType.Unidentified.key },
};

export default RankingScope;